module.exports = __webpack_public_path__ + "static/img/stephanie-harvey-vHkj3fX9wCk-unsplash_thumb.8558a41.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ads/standard_bg/stephanie-harvey-vHkj3fX9wCk-unsplash_thumb.png
// module id = ktsG
// module chunks = 4